import { render, staticRenderFns } from "./BookOrderData.vue?vue&type=template&id=0cd7bcef&scoped=true"
import script from "./BookOrderData.vue?vue&type=script&lang=js"
export * from "./BookOrderData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7bcef",
  null
  
)

export default component.exports